import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '@capturum/auth';
import { LoginService } from '../login.service';
import { LoginAction } from '../base/login-action.enum';

@Component({
  selector: 'cap-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ResetPasswordComponent implements OnInit {
  public form: FormGroup;
  public resetError: boolean;
  public emailError: boolean;
  public resetSuccess: boolean;

  private token: string;

  constructor(
    private route: ActivatedRoute,
    private authService: AuthService,
    private loginService: LoginService
  ) {

    this.emailError = false;
    this.resetError = false;
    this.resetSuccess = false;
  }

  public ngOnInit(): void {
    this.createForm();

    this.route.params.subscribe((params) => {
      if (params.token) {
        this.token = params.token;
      }

      if (params.email) {
        this.form.patchValue({ email: params.email });
        this.form.get('email').disable();
        this.form.get('email').updateValueAndValidity();
      }
    });
  }

  public submit(): void {
    this.emailError = false;
    this.resetError = false;
    this.resetSuccess = false;

    for (const key in this.form.controls) {
      if (this.form.get(key)) {
        this.form.get(key).markAsTouched();
      }
    }

    if (this.form.valid) {
      this.form.get('email').enable();
      const { email, password, password_confirmation } = this.form.value;

      this.authService.resetPassword({ token: this.token, email, password, password_confirmation }).subscribe(
        (response) => {
          this.loginService.setAction(LoginAction.reset, true);
          this.loginService.onResetSuccess(response);
          this.resetSuccess = true;
        },
        (error) => {
          this.loginService.setAction(LoginAction.reset, false);
          this.resetError = true;
          this.loginService.onResetFail(error);
        }
      );
    } else {
      this.emailError = true;
    }
  }

  /**
   * Create fields for reset password form
   */
  private createForm(): void {
    this.form = this.loginService.resetForm;
  }
}
